
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabresultParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}


export interface Labresultmst {


         id?: number;
         labId: any;
         status:any
         sampleDate :Date;
         completedDate:Date;
         printDate :Date;
         resultStatus :string;
         labResultNo :any;
         regId :any;
         type:any
         iPID :any;
         physicianId :any; 
         entryDate :Date;
         labOrderFrom:string;
         billId :any;


    parameters?: LabresultParameter[];
    links?: any;
}


export abstract class LabresultmstData {
    //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
    abstract list(url: string): Observable<Labresultmst[]>;
    abstract create(url: string,data: Labresultmst): Observable<any>;
    abstract update(url: string,data: Labresultmst): Observable<any>;
    abstract delete(url: string): Observable<any>;
  }
